package org.ssoft.common.type

interface BitMask : Mask {

    override infix fun match(mask: Int): Boolean = this.mask and mask > 0


    companion object {
        operator fun <T : Mask> get(mask: Int, items: List<T>) = items.filter { it match mask }
    }
}